// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".half-circle-spinner .circle-1{border-top-color:#4fb3ce!important}.half-circle-spinner .circle-2{border-bottom-color:#f37321!important}.v-application--wrap{font-family:Open Sans!important}.v-application--wrap h1.display-1,.v-application--wrap h2.display-1,.v-application--wrap h3.display-1{color:#51307d;margin-bottom:16px}", ""]);
// Exports
exports.locals = {
	"primary": "#002b5c",
	"primaryLight": "#4fb3ce",
	"secondary": "#4fb3ce",
	"secondaryBright": "#badaf3",
	"accent": "#f37321",
	"neutralLight": "#d9d9d9",
	"neutralBright": "#fff",
	"brandGrey": "#cfd5dd",
	"success": "#095",
	"textColor": "#333",
	"textBright": "#fff",
	"textLinks": "#333",
	"headerColor": "#4fb3ce"
};
module.exports = exports;
